// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { EMPTY_STRING } from '~/utils/constants/common';
import { IFormChangePassword } from '~/utils/interface/user';

export const schema = (t: TFunction) => {
  return yup
    .object()
    .shape({
      currentPassword: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' }))
        .min(8, t('change_password_password_min'))
        .max(100, t('change_password_password_max'))
        .test('not-same-as-new', t('change_password_different_new_password'), function (value) {
          const { newPassword } = this.parent;
          return !(value && newPassword && value === newPassword);
        }),
      newPassword: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' }))
        .min(8, t('change_password_password_min'))
        .max(100, t('change_password_password_max'))
        .test('not-same-as-current', t('change_password_different_current_password'), function (value) {
          const { currentPassword } = this.parent;
          if (value && value === currentPassword) {
            return false;
          }
          return true;
        }),
      confirmNewPassword: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' }))
        .test('not-same-as-new', t('new_password_confirm_new_password_not_match'), function (value) {
          const { newPassword } = this.parent;
          return value && newPassword && value === newPassword;
        }),
    })
    .required();
};

export const defaultValues: IFormChangePassword = {
  currentPassword: EMPTY_STRING,
  newPassword: EMPTY_STRING,
  confirmNewPassword: EMPTY_STRING,
};
